import gql from 'graphql-tag'

export default gql`
mutation CreateAutomationTask($fields: ShopTaskCreateInput!) {
  cashAssist {
    createAutomationTask(fields: $fields) {
      id
      name
    }
  }
}`
